import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'
import { IAppointment } from '../../types'
import { IAPIAppointment } from '../../types/api'
import { apiAppointmentTransformer } from '../transformer/apiAppointmentTransformer'

type TGetAppointmentReturn = {
  data: IAppointment
  type: 'create' | 'update' | 'delete'
}

export const fetchAppointment = createAsyncThunk<
  TGetAppointmentReturn,
  { uuid: string; type: 'create' | 'update' | 'delete' },
  IThunkReject<any>
>('appointment/fetch', async (formObject, { rejectWithValue }) => {
  const { uuid, type } = formObject
  let apiData: null | TGetAppointmentReturn = null

  try {
    const promise = clientSDK
      .instance()
      .get<IAPIAppointment>(`calendar/appointments/${uuid}`)

    const result = await promise

    apiData = {
      data: apiAppointmentTransformer(result.data),
      type,
    }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
